// @flow strict

export const SUPPORTED_LANGUAGES = [
  'en',
  'fr-CA',
  'es-419',
  'it',
  'fr',
  'es',
  'de',
  'hu',
  'ja',
  'nl',
  'pt',
  'sv',
];

export const languageMenuOptions = [
  {label: 'English', key: 'en'},
  {label: 'Français canadien', key: 'fr-CA'},
  {label: 'Español latinoamericano', key: 'es-419'},
  {label: 'Italiano', key: 'it'},
  {label: 'Français', key: 'fr'},
  {label: 'Español', key: 'es'},
  {label: 'Deutsch', key: 'de'},
  {label: 'Magyar', key: 'hu'},
  {label: '日本語', key: 'ja'},
  {label: 'Nederlands', key: 'nl'},
  {label: 'Português', key: 'pt'},
  {label: 'Svenska', key: 'sv'},
];
